import { render, staticRenderFns } from "./iosDownIntroductionPage.vue?vue&type=template&id=bbd08600&scoped=true"
import script from "./iosDownIntroductionPage.vue?vue&type=script&lang=js"
export * from "./iosDownIntroductionPage.vue?vue&type=script&lang=js"
import style0 from "./iosDownIntroductionPage.vue?vue&type=style&index=0&id=bbd08600&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbd08600",
  null
  
)

export default component.exports